<template>
    <div>
        <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">

            <c-panel title="1. IDENTIFICAÇÃO" titleIcon="fas fa-id-card">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Aluno" prop="aluno_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.aluno_id"
                                       filterable remote :remote-method="searchAluno"
                                       :loading="loadingAluno" clearable
                                       placeholder="Digite o nome do aluno...">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Ano" prop="ano" :rules="[$requiredBlur]">
                            <el-input v-model="dados.ano" v-mask="'####'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Data de preenchimento">
                            <el-input v-model="dados.data_preenchimento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Responsável">
                            <el-input v-model="identif.responsavel"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Professor do AEE (servidor)">
                            <el-select v-model="dados.professor_aee_servidor_id"
                                       filterable remote :remote-method="searchServidor"
                                       :loading="loadingServidor" clearable
                                       placeholder="Digite o nome do servidor...">
                                <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Escola regular">
                            <el-input v-model="identif.escola_regular"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Escola da sala de recursos">
                            <el-input v-model="identif.escola_sala_recursos"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Professor regular">
                            <el-input v-model="identif.professor_regular"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24">
                        <el-form-item label="Motivo do encaminhamento">
                            <el-input type="textarea" :rows="3" v-model="identif.motivo_encaminhamento"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="3. ORGANIZAÇÃO DO ATENDIMENTO" titleIcon="fas fa-tasks">
                <el-form-item label="Tempo">
                    <el-checkbox-group v-model="atendimento.tempo">
                        <el-checkbox v-for="o in $CONSTANTS.PDI_TEMPO" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                    </el-checkbox-group>
                    <el-input v-if="(atendimento.tempo || []).indexOf('outros') >= 0" v-model="atendimento.tempo_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                </el-form-item>
                <el-form-item label="Composição">
                    <el-checkbox-group v-model="atendimento.composicao">
                        <el-checkbox v-for="o in $CONSTANTS.PDI_COMPOSICAO" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                    </el-checkbox-group>
                    <el-input v-if="(atendimento.composicao || []).indexOf('outros') >= 0" v-model="atendimento.composicao_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                </el-form-item>
                <el-form-item label="Profissionais envolvidos">
                    <el-checkbox-group v-model="atendimento.profissionais">
                        <el-checkbox v-for="o in $CONSTANTS.PDI_PROFISSIONAIS" :key="o.v" :label="o.v">{{ o.l }}</el-checkbox>
                    </el-checkbox-group>
                    <el-input v-if="(atendimento.profissionais || []).indexOf('outros') >= 0" v-model="atendimento.profissionais_outro" placeholder="Especificar..." class="u-mt-5"></el-input>
                </el-form-item>

                <h4 style="margin-top: 14px;">Orientações</h4>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" v-for="campo in orientacoesCampos" :key="campo.v">
                        <el-form-item :label="campo.l">
                            <el-input type="textarea" :rows="2" v-model="orientacoes[campo.v]"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="4. AVALIAÇÃO DO ALUNO" titleIcon="fas fa-stethoscope">
                <el-form-item label="4.1 Estudo de Caso (diagnósticos, medicamentos, recomendações)">
                    <el-input type="textarea" :rows="4" v-model="avaliacao.estudo_caso"></el-input>
                </el-form-item>
                <el-form-item label="4.2 Necessidades Específicas">
                    <el-input type="textarea" :rows="4" v-model="avaliacao.necessidades_especificas"></el-input>
                </el-form-item>
            </c-panel>

            <c-panel v-for="area in $CONSTANTS.PDI_AREAS" :key="area.v" :title="area.l.toUpperCase()" titleIcon="fas fa-layer-group">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Estratégias">
                            <el-input type="textarea" :rows="3" v-model="getArea(area.v).estrategias"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Recursos / Tecnologia Assistiva">
                            <el-input type="textarea" :rows="3" v-model="getArea(area.v).recursos"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="13. MATERIAIS/EQUIPAMENTOS PARA AQUISIÇÃO" titleIcon="fas fa-box-open">
                <el-checkbox-group v-model="materiais">
                    <el-checkbox v-for="o in $CONSTANTS.PDI_MATERIAIS" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(materiais || []).indexOf('outros') >= 0" v-model="materiaisOutro" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="14. ATIVIDADES DIFERENCIADAS" titleIcon="fas fa-puzzle-piece">
                <el-checkbox-group v-model="atividadesDiferenciadas">
                    <el-checkbox v-for="o in $CONSTANTS.PDI_ATIVIDADES_DIFERENCIADAS" :key="o.v" :label="o.v" style="margin-bottom: 6px;">{{ o.l }}</el-checkbox>
                </el-checkbox-group>
                <el-input v-if="(atividadesDiferenciadas || []).indexOf('outros') >= 0" v-model="atividadesDiferenciadasOutro" placeholder="Especificar..." class="u-mt-5"></el-input>
            </c-panel>

            <c-panel title="15. PARCERIAS" titleIcon="fas fa-handshake">
                <el-form-item>
                    <el-input type="textarea" :rows="3" v-model="dadosForm.parcerias"></el-input>
                </el-form-item>
            </c-panel>

            <c-panel title="16. CRITÉRIOS E MÉTODOS DE AVALIAÇÃO" titleIcon="fas fa-check-double">
                <el-form-item>
                    <el-input type="textarea" :rows="4" v-model="dadosForm.criterios_avaliacao"></el-input>
                </el-form-item>
            </c-panel>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="12">
                    <el-form-item>
                        <el-checkbox v-model="dados.finalizado">Marcar como finalizado</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button v-if="dados.id" type="primary" @click="imprimir">IMPRIMIR</el-button>
                    <el-button class="u-ml-10" type="primary" id="btn-pdi" native-type="submit">SALVAR</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
const novaArea = () => ({ estrategias: '', recursos: '' })

export default {
    props: ['paramId'],
    data: () => ({
        edit: false,
        loadingAluno: false,
        loadingServidor: false,
        alunos: [],
        servidores: [],
        orientacoesCampos: [
            { v: 'professor_regular', l: 'Professor regular' },
            { v: 'ed_fisica', l: 'Educação física' },
            { v: 'colegas', l: 'Colegas' },
            { v: 'diretor', l: 'Diretor' },
            { v: 'coordenador', l: 'Coordenador' },
            { v: 'familia', l: 'Família' },
            { v: 'funcionarios', l: 'Funcionários' },
        ],
        dados: {
            id: '',
            aluno_id: '',
            instituicao_id: null,
            ano: new Date().getFullYear(),
            periodo_letivo_id: null,
            professor_aee_servidor_id: null,
            data_preenchimento: '',
            finalizado: false
        },
        identif: { responsavel: '', escola_regular: '', escola_sala_recursos: '', professor_regular: '', motivo_encaminhamento: '' },
        atendimento: { tempo: [], tempo_outro: '', composicao: [], composicao_outro: '', profissionais: [], profissionais_outro: '' },
        orientacoes: {},
        avaliacao: { estudo_caso: '', necessidades_especificas: '' },
        areas: {
            cognitiva: novaArea(), interacao_social: novaArea(), linguagem: novaArea(),
            motoras: novaArea(), avd: novaArea(), leitora: novaArea(),
            matematica: novaArea(), artistica: novaArea()
        },
        materiais: [],
        materiaisOutro: '',
        atividadesDiferenciadas: [],
        atividadesDiferenciadasOutro: '',
        dadosForm: { parcerias: '', criterios_avaliacao: '' }
    }),
    methods: {
        getArea (chave) {
            if (!this.areas[chave]) this.$set(this.areas, chave, novaArea())
            return this.areas[chave]
        },
        searchAluno (query) {
            if (!query) { this.alunos = []; return }
            this.loadingAluno = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => { this.alunos = response.data || [] })
              .catch(() => {}).finally(() => { this.loadingAluno = false })
        },
        searchServidor (query) {
            if (!query) { this.servidores = []; return }
            this.loadingServidor = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(response => { this.servidores = response.data || [] })
              .catch(() => {}).finally(() => { this.loadingServidor = false })
        },
        getById (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/plano-pdi/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    const r = response.data || {}
                    this.dados = Object.assign({}, this.dados, {
                        id: r.id, aluno_id: r.aluno_id, instituicao_id: r.instituicao_id,
                        ano: r.ano, periodo_letivo_id: r.periodo_letivo_id,
                        professor_aee_servidor_id: r.professor_aee_servidor_id,
                        data_preenchimento: r.data_preenchimento ? this.$moment(r.data_preenchimento).format('DD/MM/YYYY') : '',
                        finalizado: !!r.finalizado
                    })
                    if (r.aluno) this.alunos = [r.aluno]
                    if (r.professor_aee) this.servidores = [r.professor_aee]
                    const d = r.dados || {}
                    this.identif = Object.assign({ responsavel: '', escola_regular: '', escola_sala_recursos: '', professor_regular: '', motivo_encaminhamento: '' }, d.identificacao || {})
                    const at = d.atendimento || {}
                    this.atendimento = {
                        tempo: at.tempo || [], tempo_outro: at.tempo_outro || '',
                        composicao: at.composicao || [], composicao_outro: at.composicao_outro || '',
                        profissionais: at.profissionais || [], profissionais_outro: at.profissionais_outro || ''
                    }
                    this.orientacoes = Object.assign({}, at.orientacoes || {})
                    this.avaliacao = Object.assign({ estudo_caso: '', necessidades_especificas: '' }, d.avaliacao || {})
                    const areasIn = d.areas || {}
                    Object.keys(this.areas).forEach(k => {
                        this.$set(this.areas, k, Object.assign(novaArea(), areasIn[k] || {}))
                    })
                    this.materiais = d.materiais || []
                    this.materiaisOutro = d.materiais_outro || ''
                    this.atividadesDiferenciadas = d.atividades_diferenciadas || []
                    this.atividadesDiferenciadasOutro = d.atividades_diferenciadas_outro || ''
                    this.dadosForm = { parcerias: d.parcerias || '', criterios_avaliacao: d.criterios_avaliacao || '' }
                }).catch((error) => { this.$store.commit('throwException', error) })
                .finally(() => { window.eventBus.$emit('loading', false) })
        },
        buildPayload () {
            const inst = this.$store.state.config && this.$store.state.config.instituicao ? this.$store.state.config.instituicao : null
            const dataPreench = this.dados.data_preenchimento && this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY', true).isValid()
                ? this.$moment(this.dados.data_preenchimento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            return {
                aluno_id: this.dados.aluno_id,
                instituicao_id: inst ? inst.id : this.dados.instituicao_id,
                ano: parseInt(this.dados.ano) || new Date().getFullYear(),
                periodo_letivo_id: this.dados.periodo_letivo_id,
                professor_aee_servidor_id: this.dados.professor_aee_servidor_id,
                data_preenchimento: dataPreench,
                finalizado: !!this.dados.finalizado,
                dados: {
                    identificacao: this.identif,
                    atendimento: {
                        tempo: this.atendimento.tempo,
                        tempo_outro: this.atendimento.tempo_outro,
                        composicao: this.atendimento.composicao,
                        composicao_outro: this.atendimento.composicao_outro,
                        profissionais: this.atendimento.profissionais,
                        profissionais_outro: this.atendimento.profissionais_outro,
                        orientacoes: this.orientacoes
                    },
                    avaliacao: this.avaliacao,
                    areas: this.areas,
                    materiais: this.materiais,
                    materiais_outro: this.materiaisOutro,
                    atividades_diferenciadas: this.atividadesDiferenciadas,
                    atividades_diferenciadas_outro: this.atividadesDiferenciadasOutro,
                    parcerias: this.dadosForm.parcerias,
                    criterios_avaliacao: this.dadosForm.criterios_avaliacao
                }
            }
        },
        onSubmit () {
            document.getElementById('btn-pdi').focus()
            this.$refs.dados.validate((valid) => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const payload = this.buildPayload()
                const url = this.edit
                    ? `${this.$store.state.config.baseUrlApi}/api/plano-pdi/update/` + this.dados.id
                    : `${this.$store.state.config.baseUrlApi}/api/plano-pdi/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        window.eventBus.$emit('loading', false)
                        if (response.data && response.data.erro) {
                            const t = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
                            window.eventBus.$emit('alert', { msg: t, type: 'warning' })
                            return
                        }
                        window.eventBus.$emit('alert', { msg: 'PEI/Sala Regular salvo com sucesso.', type: 'success' })
                        this.$emit('onSubmit')
                    })
                    .catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
            })
        },
        imprimir () {
            if (!this.dados.id) return
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/plano-pdi/imprimir/${this.dados.id}`,
                this.$store.getters.getHeaderAuthExcel
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.edit = true
                    this.getById(value)
                }
            }
        }
    }
}
</script>
